import { LoadableBackground } from '@confluence/loadable';

export const Heartbeat = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Heartbeat" */ './Heartbeat.tsx')).Heartbeat,
});
